import { withDeadline } from 'src/app/core/services/maintenance/failure-diagnostics';
import { Injectable } from '@angular/core';
import { UserBackendService } from 'src/app/core/backend-services';
import { OnlineStatusEnum } from 'src/app/core/enums/online-status/online-status.enum';
import { PlayerInterface } from 'src/app/core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PlayerUtilService {
  constructor(private userBackendService: UserBackendService) {}

  public async updateFromBackend(player: PlayerInterface) {
    await Promise.all([
      this.updateOnlineStatus(player),
      this.updatePoints(player),
    ]);
  }

  public async updateOnlineStatus(player: PlayerInterface) {
    if (!player.userID) return;
    try {
      const info = await withDeadline(this.userBackendService.getOnlineInfo(player.userID), 5000);

      if (info.isOnline) {
        if (info.isInactive) {
          player.onlineStatus = info.isVeryInactive
            ? OnlineStatusEnum.UNRESPONSIVE
            : OnlineStatusEnum.NOT_REACTING;
        } else {
          player.onlineStatus = OnlineStatusEnum.ONLINE;
        }
      } else {
        player.onlineStatus = OnlineStatusEnum.OFFLINE;
      }
    } catch (e) {
      console.warn(
        `Did not update player online status for userID ${player.userID}: `,
        e
      );
    }
  }

  public async updatePoints(player: PlayerInterface) {
    if (!player.userID) return;
    try {
      const info = await withDeadline(this.userBackendService.getPlayerInfo(player.userID), 5000);
      player.points = info.points;
      // refresh the Stammgast badge too (subscription may have changed since joining)
      if (info.premiumBadge !== undefined) player.premiumBadge = info.premiumBadge || undefined;
    } catch (e) {
      console.warn(
        `Did not update player points for userID ${player.userID}: `,
        e
      );
    }
  }
}
